/** Calls flow's own API (same origin, /api/*) with the signed-in judge's token. */

export class ApiError extends Error {
  constructor(readonly status: number, readonly body: unknown) {
    super(`API ${status}`);
  }
}

export const apiFetch = async <T,>(path: string, getToken: () => Promise<string | null>, init: RequestInit = {}): Promise<T> => {
  const token = await getToken();
  if (!token) throw new ApiError(401, { error: 'unauthenticated' });
  const headers = new Headers(init.headers);
  headers.set('authorization', `Bearer ${token}`);
  if (init.body && !headers.has('content-type')) headers.set('content-type', 'application/json');
  const res = await fetch(path, { ...init, headers });
  const body = res.headers.get('content-type')?.includes('json') ? await res.json() : await res.text();
  if (!res.ok) throw new ApiError(res.status, body);
  return body as T;
};
